import React,{createContext,useContext,useState} from 'react'
export const NotificationContext=createContext(null)
export const useNotifications=()=>useContext(NotificationContext)
export const NotificationProvider=({children})=>{
 const [notifications,setNotifications]=useState([])
 const [settings,setSettings]=useState({
  tasks:{enabled:false,dueSoon:false,overdue:false,completed:false},
  events:{enabled:false,reminders:false,reminderTime:30},
  family:{enabled:false},system:{enabled:false},
  budget:{enabled:false,alerts:false,monthlyReport:false},
  maintenance:{enabled:false,reminders:false},
  shopping:{enabled:false,listUpdates:false},
  general:{sound:false,vibration:false,quietHours:{start:'22:00',end:'08:00'}}
 })
 const addNotification=notification=>setNotifications(p=>[{...notification,id:crypto.randomUUID(),timestamp:new Date().toISOString(),read:false},...p].slice(0,50))
 const markAsRead=id=>setNotifications(p=>p.map(n=>n.id===id?{...n,read:true}:n))
 const markAllAsRead=()=>setNotifications(p=>p.map(n=>({...n,read:true})))
 const removeNotification=id=>setNotifications(p=>p.filter(n=>n.id!==id))
 const clearAll=()=>setNotifications([])
 const updateSettings=next=>setSettings(p=>({...p,...next}))
 const isPermissionGranted=typeof window!=='undefined' && 'Notification' in window && window.Notification.permission==='granted'
 return <NotificationContext.Provider value={{notifications,unreadCount:notifications.filter(n=>!n.read).length,addNotification,markAsRead,markAllAsRead,removeNotification,clearAll,settings,setSettings,updateSettings,isPermissionGranted}}>{children}</NotificationContext.Provider>
}
